import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgArrowRotateLeft = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M5.5 4.752a.75.75 0 0 1 .75.75v3.19c1.24-2.079 3.51-3.437 6.003-3.437a7.003 7.003 0 0 1 6.997 6.997A7.003 7.003 0 0 1 7.769 17.63a.75.75 0 1 1 .96-1.153 5.52 5.52 0 0 0 3.521 1.274c3.032 0 5.5-2.468 5.5-5.5s-2.469-5.5-5.5-5.5c-2.08 0-3.963 1.196-4.89 3h3.14a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75v-5a.75.75 0 0 1 .75-.75"
    }));
export default SvgArrowRotateLeft;
